module.exports = __webpack_public_path__ + "img/公司.4bce027f.png";